var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPlayStream(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "33px",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPlayStream") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DESKTOP-CHAT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chat-group-updated",
    transform: "translate(-527.000000, -142.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M543.451613,142 C534.380194,142 527,149.380194 527,158.451613 C527,167.523032 534.380194,174.903226 543.451613,174.903226 C552.523032,174.903226 559.903226,167.523032 559.903226,158.451613 C559.903226,149.380194 552.523032,142 543.451613,142 Z M551.914597,158.901224 L539.495242,167.066572 C539.399839,167.129173 539.288629,167.16129 539.177419,167.16129 C539.087097,167.16129 538.99621,167.140605 538.91379,167.098145 C538.728629,167.003971 538.612903,166.81889 538.612903,166.616934 L538.612903,150.286237 C538.612903,150.08428 538.728629,149.899199 538.91379,149.805025 C539.098952,149.710307 539.3225,149.723372 539.495806,149.836598 L551.915161,158.001947 C552.06871,158.103197 552.16129,158.271403 552.16129,158.451585 C552.16129,158.631767 552.06871,158.799973 551.914597,158.901224 Z",
    id: "icPlayStream"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlayStream);
export default __webpack_public_path__ + "static/media/icPlayStream.ff19ac216e4fecd433b1bcac34648357.svg";
export { ForwardRef as ReactComponent };